import React, { useState } from 'react';
import axios from '../../api/axios'
import { useNavigate } from 'react-router-dom';
import '../../styles/loginPage.css';
import '../../styles/register.css';
import { notify } from '../toast';

const RegistrationForm = () => {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [area, setArea] = useState('');
  const [about, setAbout] = useState('');
  const [village, setVillage] = useState('');
  const [mandal, setMandal] = useState('');
  const [district, setDistrict] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    } else if (!validateMobile(mobile) || mobile.length !== 10) {
      return setError('Invalid mobile number');
    } else {
      try {
        setLoading(true);
        const response = await axios.post('/hospitalRegister', {
          name,
          location,
          email,
          mobile,
          area,
          about,
          village,
          mandal,
          district,
          password
        });
        const res = response?.data;
        notify('success', res?.success);

        navigate('/login');
      } catch (err) {
        const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
        notify('failed', errorMessage);
      }
      finally {
        setLoading(false);
      }
    }
    setName('');
    setLocation('');
    setEmail('');
    setMobile('');
    setArea('');
    setAbout('');
    setVillage('');
    setMandal('');
    setDistrict('');
    setPassword('');
    setConfirmPassword('');
    setError('');
  };

  const validateMobile = (mobile) => {
    const re = /^[0-9]{10}$/;
    return re.test(mobile);
  };

  return (
    <div className='formContainer'>
      <div className='formWrapper'>
        <h2 className='formTitle'>Registration Form</h2>
        {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
        <form onSubmit={handleSubmit}>

          <div className='formRow'>
            <div className='formGroup'>
              <div className='formGroup'>
                <span className='formLabel'>Name</span>
                <input
                  className='formInput'
                  type="text"
                  autoFocus
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Mobile</span>
                <input
                  className='formInput'
                  type="tel"
                  value={mobile}
                  onChange={(event) => setMobile(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Location</span>
                <input
                  className='formInput'
                  type="text"
                  value={location}
                  onChange={(event) => setLocation(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Area</span>
                <input
                  className='formInput'
                  type="text"
                  value={area}
                  onChange={(event) => setArea(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>About</span>
                <textarea
                  className='formTextArea'
                  rows={3}
                  value={about}
                  onChange={(event) => setAbout(event.target.value)}
                  required
                />
              </div>
            </div>

            <div className='formGroup'>
              <div className='formGroup'>
                <span className='formLabel'>Village</span>
                <input
                  className='formInput'
                  type="text"
                  value={village}
                  onChange={(event) => setVillage(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Mandal</span>
                <input
                  className='formInput'
                  type="text"
                  value={mandal}
                  onChange={(event) => setMandal(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>District</span>
                <input
                  className='formInput'
                  type="text"
                  value={district}
                  onChange={(event) => setDistrict(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Email</span>
                <input
                  className='formInput'
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Password</span>
                <input
                  className='formInput'
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                />
              </div>
              <div className='formGroup'>
                <span className='formLabel'>Confirm Password</span>
                <input
                  className='formInput'
                  type="password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <button className='submitButton' type="submit" disabled={loading}>{loading ? <span className='spinner' /> : 'Register'}</button>

        </form>
      </div>
    </div>
  );
}

export default RegistrationForm;